// Shared Norwegian locale config for PrimeVue - used by both the admin
// bundle (site/admin/js/src/admin.js) and the public stikkut bundle
// (laravel/resources/js/frontend/components/mypage.js), so the wording only lives in one place.
export const nbLocale = {
    firstDayOfWeek: 1,
    dayNames: ['Søndag','Mandag','Tirsdag','Onsdag','Torsdag','Fredag','Lørdag'],
    dayNamesShort: ['Søn','Man','Tir','Ons','Tor','Fre','Lør'],
    dayNamesMin: ['Sø','Ma','Ti','On','To','Fr','Lø'],
    monthNames: ['Januar','Februar','Mars','April','Mai','Juni','Juli','August','September','Oktober','November','Desember'],
    monthNamesShort: ['Jan','Feb','Mar','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Des'],
    today: 'I dag',
    clear: 'Nullstill',
};
